import * as React from "react"
import type { SVGProps } from "react"
const SvgPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 5.29v7l1.7 1.7a1 1 0 0 1 .3.72v.58q0 .43-.29.7a1 1 0 0 1-.71.3h-4v5.85q0 .43-.29.7a1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-5.85H7a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-.58q0-.2.08-.39A1 1 0 0 1 6.3 14L8 12.3v-7a1 1 0 0 1-.71-.3A1 1 0 0 1 7 4.3q0-.44.29-.72A1 1 0 0 1 8 3.3h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3m-7.15 9h6.3L14 13.14V5.29h-4v7.85z" />
  </svg>
)
export default SvgPin
